"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function nxt(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5615 12.6248C19.1813 12.6248 18.873 12.345 18.873 12V11.3745H15.414C15.0337 11.3745 14.7255 11.0948 14.7255 10.7498C14.7255 10.4048 15.0337 10.125 15.414 10.125H19.5615C19.9418 10.125 20.25 10.4048 20.25 10.7498V12C20.25 12.345 19.9425 12.6248 19.5615 12.6248ZM16.1498 12.6248H17.526C17.9062 12.6248 18.2145 12.9045 18.2145 13.2495C18.2145 13.5945 17.907 13.875 17.526 13.875H15.414C15.3043 13.8753 15.196 13.8512 15.0968 13.8045L11.0828 11.3745H9.92625C9.546 11.3745 9.23775 11.0948 9.23775 10.7498C9.23775 10.4048 9.54525 10.125 9.92625 10.125H11.3025C11.451 10.125 11.5882 10.1678 11.7007 10.2405L15.6248 12.6255H16.1498V12.6248ZM11.3025 12.6248C11.6827 12.6248 11.991 12.9045 11.991 13.2495C11.991 13.5945 11.6827 13.875 11.3025 13.875H9.92625C9.81659 13.8753 9.70823 13.8512 9.609 13.8045L5.595 11.3745H4.4385C4.05825 11.3745 3.75 11.0948 3.75 10.7498C3.75 10.4048 4.0575 10.125 4.4385 10.125H5.81475C5.95583 10.1245 6.09409 10.1646 6.213 10.2405L10.137 12.6255H11.3025V12.6248ZM4.4385 12.6248H5.81475C6.195 12.6248 6.50325 12.9045 6.50325 13.2503C6.50325 13.5953 6.195 13.875 5.81475 13.875H4.4385C4.05825 13.875 3.75 13.5953 3.75 13.2503C3.75 12.9053 4.0575 12.6248 4.4385 12.6248Z", fill: color }));
}
exports["default"] = nxt;
//# sourceMappingURL=nxt.js.map